/**
 * Status of party detail definition for one party.
 * tag: 1879
 * @readonly
 * @enum {number} (int)
 */
export enum PartyDetailDefinitionStatus {
  /** Accepted */
  Accepted = 0,
  /** Accepted with changes */
  AcceptedWithChanges = 1,
  /** Rejected */
  Rejected = 2,
}
